import { render } from "./YGJDeptCascader.vue?vue&type=template&id=84601f7c&scoped=true"
import script from "./YGJDeptCascader.vue?vue&type=script&lang=js"
export * from "./YGJDeptCascader.vue?vue&type=script&lang=js"

import "./YGJDeptCascader.vue?vue&type=style&index=0&id=84601f7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84601f7c"]])

export default __exports__